import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchCallLogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('appointment/call-logs', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteCallLog(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`appointment/call-logs/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
